"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { createContext, useContext } from 'react';

const FormulaComponentsContext = createContext(null);
FormulaComponentsContext.displayName = "FormulaComponentsContext";
function useFormulaComponents() {
  const mapping = useContext(FormulaComponentsContext);
  if (!mapping) {
    throw new Error("useFormulaComponents must be used within FormulaComponentsProvider");
  }
  return mapping;
}

export { FormulaComponentsContext, useFormulaComponents };
